import { render } from "./BranchWithEmployeeView.vue?vue&type=template&id=3f366943&ts=true"
import script from "./BranchWithEmployeeView.vue?vue&type=script&lang=ts"
export * from "./BranchWithEmployeeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__